import {
  Card,
  CardBody,
  CardFooter,
  CardHeader,
  Image,
  Button,
  Spinner,
} from '@nextui-org/react';
import React from 'react';
import {
  useInfiniteQuery,
  useQueryClient,
  useMutation,
} from '@tanstack/react-query';
import Loading from '../Loading/Loading';
import { deletetopic } from '../../services/querys ';
import PostDropdown from '../PostDropdown/PostDropdown';
import { decryptData } from '../../utils/encryptData';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { message } from 'antd';

const TopicCard = ({ data, isLoading }) => {
  const { uid, rl } = useSelector((state) => state.auth);
  const loggedInUserId = decryptData(uid);
  const role = decryptData(rl);

  const navigate = useNavigate();
  const queryClient = useQueryClient();

  //delete topic
  const { mutate: deleteTopicMutation, isLoading: isDeleteTopicLoading } =
    useMutation({
      mutationFn: deletetopic,
      onError: (error) => {
        console.error('Error Delete Topic:', error);
        message.error(error?.response?.data?.error || error.message);
      },
      onSuccess: async () => {
        message.success('Topic Delete successfully');
        navigate('/community/topics');
      },
    });

  const handleDeleteTopic = () => {
    if (!data?.topicId) {
      message.error('Topic id not found');
      return;
    }
    deleteTopicMutation(data?.topicId);
  };

  return (
    <>
      <Loading isLoading={isLoading} />
      <Card className="bg-background-secondary-color">
        <CardBody>
          <div className="grid md:grid-cols-2 gap-2">
            <div className="max-w-lg">
              <Image
                loading="lazy"
                src={data?.image?.[0]?.url || '/img/fallback-image.png'}
                className="aspect-square object-cover w-full "
              />
            </div>

            <div className="md:ml-2">
              <h4 className="text-2xl font-semibold text-gray-200 font-poppins mb-3 ">
                #{data?.title}
              </h4>
              <p className="text-md text-gray-300 font-poppins leading-relaxed">
                {data?.description}
              </p>
            </div>
          </div>
        </CardBody>
        <CardFooter className="flex justify-end">
          {(data?.userId === loggedInUserId || role === 'admin') && (
            <PostDropdown deleteItem={() => handleDeleteTopic(data?.topicId)} />
          )}
        </CardFooter>
      </Card>
    </>
  );
};

export default TopicCard;
